Ply.AllocationWishlistQuantity = function(el, options) {
  this.dom = {
    el: el,
    minus: el.querySelector("[data-wishlist-minus]"),
    input: el.querySelector("[data-wishlist-input]"),
    plus: el.querySelector("[data-wishlist-plus]")
  };
  this.options = options;

  this.min = this.dom.input.disabled ? 0 : parseInt(this.dom.input.getAttribute("min"));
  this.max = this.dom.input.disabled ? 0 : parseInt(this.dom.input.getAttribute("max"));

  this.handleInputChange = this.handleInputChange.bind(this);
  this.handleButtonClick = this.handleButtonClick.bind(this);
  this.render = this.render.bind(this);

  this.dom.input.addEventListener("change", this.handleInputChange);
  this.dom.minus.addEventListener("click", this.handleButtonClick);
  this.dom.plus.addEventListener("click", this.handleButtonClick);
};

Ply.AllocationWishlistQuantity.prototype.render = function() {
  this.setValue(this.selectedQuantity());
  Ply[this.dom.input.disabled ? "addClass" : "removeClass"](this.dom.input, "uk-text-muted");
  Ply[this.isMin() ? "addClass" : "removeClass"](this.dom.minus, "uk-text-muted");
  Ply[this.isMax() ? "addClass" : "removeClass"](this.dom.plus, "uk-text-muted");
  this.dom.minus.style.cursor = this.isMin() ? "default" : "pointer";
  this.dom.plus.style.cursor = this.isMax() ? "default" : "pointer";
  this.dom.minus.disabled = this.isMin();
  this.dom.plus.disabled = this.isMax();
};

Ply.AllocationWishlistQuantity.prototype.setValue = function(newValue) {
  this.dom.input.value = parseInt(newValue);
};

Ply.AllocationWishlistQuantity.prototype.wishlistItem = function() {
  return this.options.props.wishlistItems.find(Ply.byId(this.dom.input.dataset.wishlistInput));
};

Ply.AllocationWishlistQuantity.prototype.selectedQuantity = function() {
  return (this.wishlistItem() && parseInt(this.wishlistItem().quantity)) || 0;
};

Ply.AllocationWishlistQuantity.prototype.isMin = function() {
  return this.selectedQuantity() <= this.min;
};

Ply.AllocationWishlistQuantity.prototype.isMax = function() {
  return this.selectedQuantity() >= this.max;
};

Ply.AllocationWishlistQuantity.prototype.handleInputChange = function(event) {
  if ((event.target.value >= this.min) && (event.target.value <= this.max)) {
    this.options.onChange(event);
  } else {
    if (event.target.value < this.min) {
      this.setValue(this.min);
      this.triggerChange();
    }
    if (event.target.value > this.max) {
      this.setValue(this.max);
      this.triggerChange();
    }
  }
};

Ply.AllocationWishlistQuantity.prototype.handleButtonClick = function(event) {
  switch (event.currentTarget) {
    case this.dom.minus:
      if (!this.isMin()) {
        this.setValue(this.selectedQuantity() - 1);
      }
      break;
    case this.dom.plus:
      if (!this.isMax()) {
        this.setValue(this.selectedQuantity() + 1);
      }
      break;
  }
  this.triggerChange();
};

Ply.AllocationWishlistQuantity.prototype.triggerChange = function() {
  var event = document.createEvent('HTMLEvents');
  event.initEvent('change', true, false);
  this.dom.input.dispatchEvent(event);
};
